import React from 'react'
import Header from './Header'
import Footer from './Footer'
import {config} from '../config';

function TermsOfUse(){
  return(
    <>
    <Header />
    <div className="term-condition">
      <div className="container" >
        <div className="row">
          <div className="col-md-12">
            <div className="title">
              <h3>Privacy Policy</h3>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
               <h5 className="custom-heading return">Terms of Use</h5>
                <div className="row return-policy">
                     <div className="col-md-1"></div>
                     <div className="col-md-11">
                     <div>
<p>
The following terms and conditions (these “
<strong>Terms and Conditions</strong>”) apply to your use of the {config.RestaurantName} websites, systems, and services (collectively, the “
<strong>Services</strong>). {config.RestaurantName}’ online ordering is powered
by Dining Software Group, Inc, (DiningTek). (“
<strong>{config.RestaurantName}</strong>,” “<strong>us</strong>”, “
<strong>we</strong>”, and “<strong>our</strong>”). These Terms and
Conditions apply to all customers, visitors, and users of {config.RestaurantName} sites (collectively, “<strong>User</strong>”, “
<strong>Users</strong>”, “<strong>you</strong>” and “<strong>your</strong>
”). If you do not agree to be bound by these Terms and Conditions, promptly
exit this site and cease using the Services.
</p>
<p>
<strong>Use of the Services:</strong>
</p>
<p>
Use of the Services is restricted to parties that can lawfully enter into
and form contracts under applicable law. The Services are not intended for
children under the age of 18.
</p>
<p>
You agree to comply with these Terms and Conditions, the applicable
agreements and policies that supplement these Terms and Conditions, if any,
and all applicable laws, regulations, and rules when you use the Services.
</p>
<p>
<strong>Modifications:</strong>
</p>
<p>
{config.RestaurantName} may revise and update these Terms and Conditions at any
time. Your continued use of the Services after any changes to these Terms
and Conditions shall be an acceptance of those changes.&nbsp;
</p>
<p>
We reserve the right to modify the organization, structure, or “look and
feel” of the Services, and may change, suspend, or discontinue any aspect of
the Services at any time without any liability to you or any third party. We
shall have complete and exclusive discretion over the features, functions,
prices, and other terms and conditions on which the Services are offered to
you.
</p>
<p>
<strong>Communications with {config.RestaurantName}:</strong>
</p>
<p>
{config.RestaurantName} or DiningTek may contact you by email, telephone or
otherwise in order to send you Services-related and other communications or
notices. If you do not want to receive these communications from us, you may
opt-out by following the opt-out and/or unsubscribe instructions in the
email message (if included) or by requesting to be opted-out from further
communications by emailing support@diningtek.com.
</p>
<p>
<strong>Accuracy and Integrity of Information:</strong>
</p>
<p>
Although we attempt to ensure the integrity and accurateness of the
Services, including the availability of certain restaurants or menu items,
we make no representations, warranties, or guarantees whatsoever as to the
correctness or accuracy of the Services or information therein. It is
possible that the Services could include typographical errors, inaccuracies,
or other errors, and that unauthorized additions, deletions, and alterations
could be made to the Services by third parties. In the event that an
inaccuracy arises, please inform us so that it can be corrected. Information
contained on the Services may be changed or updated without notice.
Additionally, we shall have no responsibility or liability for information
or content posted to the Services from any third party not affiliated with
{config.RestaurantName}.
</p>
<p>
<strong>{config.RestaurantName} Online Order Policy:&nbsp;</strong>
</p>
<p>
<strong>Cash Purchases:</strong>
</p>
<p>{config.RestaurantName} is responsible for collecting cash payments.&nbsp;</p>
<p>
<strong>Credit Card Purchases:</strong>
</p>
<p>
Users that choose to make purchases with credit or debit cards consent to
{config.RestaurantName}’ and/or its payment processors’ use of their payment
information to process and charge orders. Users must include all requested
information to process the payments. Users are liable to {config.RestaurantName}
for the full amount of any order placed.
</p>
<p>
<strong>Delivery and Incorrect Orders:</strong>
</p>
<p>
<strong>
If an issue with your order arises, please contact {config.RestaurantName}
immediately.&nbsp;
</strong>
{config.RestaurantName} is responsible for any issues with your order or that
may arise during the pick-up or delivery process (including orders that have
not been delivered). Users agree that the risk of loss transfers to them
upon delivery of the appropriate information to the restaurant or delivery
service. Users must file any formal claims directly with {config.RestaurantName}
or with a third party delivery service.&nbsp;&nbsp;
</p>
<p>
However, if you are unsatisfied with your order, please let {config.RestaurantName} know at&nbsp;
<a href="mailto:support@diningtek.com">support@diningtek.com</a>&nbsp;as we
may use that information to help remedy the situation and/or improve future
service to our Users. Include all information regarding your order,
including order number, restaurant name, date, and amount of the order, the
order, and the order mistake.
</p>
<p>
<strong>Refunds:</strong>
</p>
<p>
All orders are non-refundable. However, {config.RestaurantName} may, in its sole
discretion, cancel and refund orders. This may occur if items are
out-of-stock or unavailable. {config.RestaurantName} may choose to refund all or
part of an order in their sole discretion or as required by their policies.
</p>
<p>
<strong>Disclaimers and Exclusions:</strong>
</p>
<p>
{config.RestaurantName} PROVIDES THE SERVICES ON AN “AS IS” AND “AS AVAILABLE”
BASIS, WITH ALL FAULTS AND WITHOUT WARRANTY OF ANY KIND. {config.RestaurantName}
DOES NOT REPRESENT OR WARRANT THAT THE SERVICES OR THEIR USE: (I) WILL BE
UNINTERRUPTED; (II) WILL BE FREE OF INACCURACIES OR ERRORS; (III) WILL MEET
YOUR REQUIREMENTS OR EXPECTATIONS; OR (IV) WILL OPERATE IN THE CONFIGURATION
OR WITH THE HARDWARE OR SOFTWARE YOU USE. {config.RestaurantName} MAKES NO
WARRANTIES OTHER THAN THOSE MADE EXPRESSLY IN THESE TERMS AND CONDITIONS,
AND HEREBY DISCLAIMS ANY AND ALL IMPLIED WARRANTIES, INCLUDING WITHOUT
LIMITATION, WARRANTIES OF FITNESS FOR A PARTICULAR PURPOSE, MERCHANTABILITY,
TITLE, AND NON-INFRINGEMENT. {config.RestaurantName} DOES NOT WARRANT THE
ACCURACY, COMPLETENESS, OR TIMELINESS OF THE INFORMATION OBTAINED THROUGH
THE SERVICES.
</p>
<p>
{config.RestaurantName} disclaims any representations or warranties concerning
any internet outage, technical issue, food order delay, order
misinterpretation, food quality, food quantity, difference in orders,
missing order information, missing payment method, payment processing
errors, overpayments, missing tax, regulatory fees, cash exchange, or any
fees caused by technical errors.&nbsp;&nbsp;
</p>
<p>
However, {config.RestaurantName} is committed to helping resolve any issues that
may arise when using the {config.RestaurantName} online order system powered by
DiningTek. In any case of errors please contact {config.RestaurantName}
immediately through email at&nbsp;
<a href="mailto:support@diningtek.com">support@diningtek.com</a>.
</p>
<p>
<strong>Limitation of Liability:</strong>
</p>
<p>
{config.RestaurantName} SPECIFICALLY DISCLAIMS ANY LIABILITY, WHETHER BASED IN
CONTRACT, TORT, STRICT LIABILITY OR OTHERWISE, FOR ANY DIRECT, INDIRECT,
INCIDENTAL, CONSEQUENTIAL, OR SPECIAL DAMAGES ARISING OUT OF OR IN ANY WAY
CONNECTED WITH ACCESS TO OR USE OF THE SERVICES, EVEN IF {config.RestaurantName}
HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, INCLUDING BUT NOT
LIMITED TO RELIANCE BY ANY PARTY ON ANY CONTENT OBTAINED THROUGH THE USE OF
THE SERVICES, OR THAT ARISES IN CONNECTION WITH MISTAKES OR OMISSIONS IN, OR
DELAYS IN TRANSMISSION OF, INFORMATION TO OR FROM THE USER, INTERRUPTIONS IN
TELECOMMUNICATIONS CONNECTIONS TO THE SERVICES OR VIRUSES, WHETHER CAUSED IN
WHOLE OR IN PART BY NEGLIGENCE, ACTS OF GOD, TELECOMMUNICATIONS FAILURE,
THEFT OR DESTRUCTION OF, OR UNAUTHORIZED ACCESS TO THE SERVICES, OR RELATED
INFORMATION OR PROGRAMS.
</p>
<p>
<strong>Indemnification:</strong>
</p>
<p>
You agree to indemnify, defend, and hold harmless {config.RestaurantName}, its
directors, officers, employees, consultants, agents, and other
representatives, from and against any and all claims, damages, losses, costs
(including reasonable attorneys’ fees), and other expenses that arise
directly or indirectly out of or from (a) your breach of these Terms and
Conditions; (b) any allegation that any materials you submit to us infringe
or otherwise violate the copyright, trademark, trade secret, or other
intellectual property or other rights of any third party; and (c) your
activities in connection with the Services.
</p>
<p>
<strong>Trademarks:</strong>
</p>
<p>
The {config.RestaurantName} name and logo, and all other trademarks, service
marks and trade names in relation to the Services (collectively, “
<strong>Marks</strong>”) are owned by {config.RestaurantName} and may not be
used in any manner without the express written consent of {config.RestaurantName}. Unauthorized use of any Marks may be a violation of federal and
state trademark laws.
</p>
<p>
<strong>License and Ownership:</strong>
</p>
<p>
Any and all intellectual property rights (“
<strong>Intellectual Property</strong>”) associated with the Services and
its contents (the “<strong>Content</strong>”) including, without limitation,
text, video, graphics, logos, images, digital downloads, software, and
instructional materials and curricula, are the sole property of {config.RestaurantName}, its affiliates or third parties. The Content is protected by
copyright and other laws in both the United States and other countries.
Elements of the Services are also protected by trade dress, trade secret,
unfair competition, and other laws and may not be copied or imitated in
whole or in part. Except as otherwise expressly authorized by these Terms
and Conditions, you may not copy, reproduce, modify, lease, loan, sell,
create derivative works from, upload, transmit or distribute the
Intellectual Property of the Services in any way without the {config.RestaurantName}’s or the appropriate third party’s prior written permission. Except
as expressly provided herein, {config.RestaurantName} does not grant to you any
express or implied rights to {config.RestaurantName}’s or any third party’s
Intellectual Property.&nbsp;
</p>
<p>
{config.RestaurantName} grants you a limited, personal, nontransferable,
nonsublicensable, revocable license to access and use the Services only in
the manner presented by {config.RestaurantName}. Except for this limited
license, {config.RestaurantName} does not convey any interest in or to the
Content or Services or any other {config.RestaurantName} property by permitting
you to access the Services. Except to the extent required by law or as
expressly provided herein, none of the Content may be reverse-engineered,
modified, reproduced, republished, translated into any language or computer
language, re-transmitted in any form or by any means, resold or
redistributed without the prior written consent of {config.RestaurantName}. You
may not make, sell, offer for sale, modify, reproduce, display, publicly
perform, import, distribute, retransmit or otherwise use the Content in any
way, unless expressly permitted to do so by {config.RestaurantName}.
</p>
<p>
<strong>Security:</strong>
</p>
<p>
You understand and acknowledge that no data transmission over the Internet
can be guaranteed to be 100% secure, and that while {config.RestaurantName}
engages industry standard payment processors and internet infrastructure
providers, we cannot guarantee that any information you submit to us will be
free from unauthorized third-party intrusion. You understand and agree that
all information you submit to {config.RestaurantName} is done so at your own
risk.
</p>
<p>
<strong>Restrictions on Site Use:</strong>
</p>
<p>
In addition to other restrictions set forth in these Terms and Conditions,
you agree that:
</p>
<p>
(a) You shall not disguise the origin of information transmitted through the
Services.
</p>
<p>(b) You will not place false or misleading information on the Services.</p>
<p>
(c) You will not use or access any service, information, application or
software available via the Services in a manner not expressly permitted by
{config.RestaurantName}.
</p>
<p>
(d) You will not input or upload to the Services any information which
contains viruses, Trojan horses, worms, time bombs or other computer
programming routines that are intended to damage, interfere with, intercept
or expropriate any system, the Services or Content, or that infringes the
Intellectual Property rights of another.
</p>
<p>
(e) You may not use or access the Services in any way that, in {config.RestaurantName}’ judgment, adversely affects the performance or function of the
Services or interferes with the ability of authorized parties to access the
Services.
</p>
<p>
(f) You may not frame or utilize framing techniques to enclose any portion
or aspect of the Content or the Services without the express written consent
of {config.RestaurantName}.
</p>
<p>
<strong>Termination:</strong>
</p>
<p>
{config.RestaurantName} may, in its sole discretion, terminate or suspend your
use of the Services at any time and for any or no reason, even if we
continue to allow others to access and use the Services.
</p>
<p>
<strong>Arbitration:</strong>
</p>
<p>
Any dispute between you and {config.RestaurantName}, its agents, employees,
officers, directors, principals, successors, assigns, subsidiaries or
affiliates arising from or relating to these Terms and Conditions and their
interpretation or the breach, termination or validity thereof, the
relationships which result from these Terms and Conditions, including
disputes about the validity, scope or enforceability of this arbitration
provision (collectively, “<strong>Covered Disputes</strong>”) will be
settled by binding arbitration in accordance with the rules of the American
Arbitration Association by a single arbitrator appointed in accordance with
said rules. Prior to initiating any arbitration, the initiating party will
give the other party at least 60-days’ advanced written notice of its intent
to file for arbitration. {config.RestaurantName} will provide such notice by
e-mail to your e-mail address on file with {config.RestaurantName} and you must
provide such notice by e-mail to&nbsp;
<a href="mailto:support@diningtek.com">support@diningtek.com</a>
</p>
<p>
During such 60-day notice period, the parties will endeavor to settle
amicably by mutual discussions any Covered Disputes. Failing such amicable
settlement and expiration of the notice period, either party may initiate
arbitration. The arbitrator will have the power to grant whatever relief
would be available in court under law or in equity and any award of the
arbitrator(s) will be final and binding on each of the parties and may be
entered as a judgment in any court of competent jurisdiction. The arbitrator
will apply applicable law and the provisions of these Terms and Conditions
and the failure to do so will be deemed an excess of arbitral authority and
grounds for judicial review. {config.RestaurantName} and you agree that any
Covered Dispute hereunder will be submitted to arbitration on an individual
basis only. Neither {config.RestaurantName} nor you are entitled to arbitrate
any Covered Dispute as a class, representative or private attorney action
and the arbitrator(s) will have no authority to proceed on a class,
representative or private attorney general basis. If any provision of the
agreement to arbitrate in this section is found illegal or unenforceable,
the remaining arbitration terms shall continue to be fully valid, binding,
and enforceable (but in no case will there be a class, representative or
private attorney general arbitration).
</p>
<p>
<strong>Assignability; Complete Agreement:</strong>
</p>
<p>
You may not assign these Terms and Conditions or any of your interests,
rights or obligations under these Terms and Conditions. If any provisions of
these Terms and Conditions is found to be invalid, the invalidity of such
provision shall not affect the validity of the remaining provisions, which
shall remain in full force and effect. No waiver of any of these Terms and
Conditions shall be deemed a further or continuing waiver of such term or
condition or any other term or condition. Except as expressly provided in a
separate, written agreement between you and {config.RestaurantName}, these Terms
and Conditions constitute the entire agreement between you and {config.RestaurantName} with respect to the Services, and supersede all discussions,
communications, conversations and agreements concerning the subject matters
thereof.
</p>
<p>
<strong>Governing Law:</strong>
</p>
<p>
The use of the Services and these Terms and Conditions will be governed by
the internal laws of the State of Colorado (without regard to conflict of
laws principles).
</p>
<p>
<strong>Copyright Infringement Claims:</strong>
</p>
<p>
If you believe that your work has been copied and is accessible on the
Services in a way that constitutes copyright infringement, or that the
Services contains links or other references to another online location that
contains material or activity that infringes your copyright rights, you may
notify {config.RestaurantName} by providing the following information (as
required by the Online Copyright Infringement Liability Limitation Act of
the Digital Millennium Copyright Act, 17 U.S.C. sec. 512) to our copyright
agent set forth below:
</p>
<p>
(a) A physical or electronic signature of the person authorized to act on
behalf of the owner of an exclusive right that is allegedly infringed;
</p>
<p>
(b) Identification of the copyrighted work claimed to have been infringed,
or if multiple copyrighted works at a single online site are covered by a
single notification, a representative list of such works at that site;
</p>
<p>
(c) Identification of the material that is claimed to be infringing, or to
be the subject of infringing activity, and that is to be removed or access
to which is to be disabled, and information reasonably sufficient to permit
{config.RestaurantName}, or its third party service providers, to locate the
material;
</p>
<p>
(d) Information reasonably sufficient to permit {config.RestaurantName}, or its
third-party service providers, to contact the complaining party, such as an
address, telephone number, and if available, an electronic mail address at
which the complaining party may be contacted;
</p>
<p>
(e) A statement that the complaining party has a good faith belief that use
of the material in the manner complained of is not authorized by the
copyright owner, its agent, or the law; and
</p>
<p>
(f) A statement that the information in the notification is accurate, and
under penalty of perjury, that the complaining party is authorized to act on
behalf of the owner of an exclusive right that is allegedly infringed.
</p>
<p>Copyright Manager</p>
<p>{config.RestaurantName}</p>
<p>
2719 Iris Ave
<br /> Boulder, CO, US, 80304
<br /> Email:&nbsp;
<a href="mailto:support@diningtek.com">support@diningtek.com</a>
</p>
</div>
                      </div>
                </div>
          </div>
        </div>
        </div>
      </div>
    <Footer />
    </>
  )
}

export default TermsOfUse;
